// extracted by mini-css-extract-plugin
export var card = "_lk-5";
export var cardSelected = "_lk-4";
export var image = "_lk-3";
export var modal = "_lk-0";
export var modalContent = "_lk-1";
export var table = "_lk-2";